/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { FilterGroupAutoComplete, FilterValue } from '../../../components';
import { useFilter } from '../useFilter';

import classes from './useSourcesFilter.module.scss';

const GROUP_ID = 'sources';

interface UseSourcesFilterArgs {
  filter: FilterValue[];
  fetchItemsQuery: any;
  fetchItemsQueryArgs: any;
}

interface SourceItem {
  name: string;
}

export const useSourcesFilter = ({
  filter,
  fetchItemsQuery,
  fetchItemsQueryArgs,
}: UseSourcesFilterArgs) => {
  const { t } = useTranslation();

  const { getGroupById } = useFilter();

  const itemTemplate = useCallback(
    ({ name }: SourceItem) => <div className={classes['name']}>{name}</div>,
    []
  );

  const autoComplete: FilterGroupAutoComplete = {
    propToIdentify: 'id',
    propToDisplay: 'name',
    fetchItemsQuery,
    fetchItemsQueryArgs,
    itemTemplate,
    placeholder: t('common.type-to-search'),
    nullOptionLabel: t('sourcesFilter.no-source'),
  };

  return {
    group: {
      id: GROUP_ID,
      title: t('sourcesFilter.title'),
      value: getGroupById({ filter, groupId: GROUP_ID })?.groupItems ?? [],
      allowReset: true,
      autoComplete,
    },
  };
};
